/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Wise_Bee_PlotInputs */

const en_bright_wise_bee_plot = /** @type {(inputs: Bright_Wise_Bee_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const de_bright_wise_bee_plot = /** @type {(inputs: Bright_Wise_Bee_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Bright_Wise_Bee_PlotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bright_wise_bee_plot = /** @type {((inputs?: Bright_Wise_Bee_PlotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Wise_Bee_PlotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bright_wise_bee_plot(inputs)
	return de_bright_wise_bee_plot(inputs)
});